import {ControllerUiLangClassList, ControllerUiLangClassId} from "./ui_lang_define"

export {controller_lang_en};

const controller_lang_en:ControllerUiLangClassList					=
{
	[ControllerUiLangClassId.MESSAGE_PORT_NOT_SELECT]: "No port selected",
	[ControllerUiLangClassId.MESSAGE_NOT_SUPPORT_BROWSER]: "Sorry, this feature is supported only on Chrome, Edge and Opera",
	[ControllerUiLangClassId.MESSAGE_PORT_USE]: "Check yours, maybe another application is using it",
	[ControllerUiLangClassId.MESSAGE_CONNECT]: "Connect device",
	[ControllerUiLangClassId.MESSAGE_DETECTION]: "Detection device",
	[ControllerUiLangClassId.MESSAGE_READ_CAPABILITIES]: "Read capabilities the device",
	[ControllerUiLangClassId.MESSAGE_READ_REGION]: "Read region the device",
	[ControllerUiLangClassId.MESSAGE_READ_SEC]: "Read securite the device",
	[ControllerUiLangClassId.MESSAGE_READ_POWER]: "Read power the device",
	[ControllerUiLangClassId.MESSAGE_READ_LICENSE]: "Read license the device",
	[ControllerUiLangClassId.MESSAGE_SET_LICENSE]: "Set license the device",
	[ControllerUiLangClassId.MESSAGE_READ_BOARD_INFO]: "Read board info the device",
	[ControllerUiLangClassId.MESSAGE_SET_REGION]: "Set region the device",
	[ControllerUiLangClassId.MESSAGE_SET_POWER]: "Set power the device",
	[ControllerUiLangClassId.MESSAGE_SET_SEC]: "Set securite the device",
	[ControllerUiLangClassId.MESSAGE_SET_DEFAULT]: "Set default the device",
	[ControllerUiLangClassId.MESSAGE_PLEASE_WAIT]: "Please wait until the previous operation is completed.",
	[ControllerUiLangClassId.MESSAGE_UPDATE_DOWNLOAD_INFO]: "Download update info",
	[ControllerUiLangClassId.MESSAGE_UPDATE_DOWNLOAD_FILE]: "Download update file",
	[ControllerUiLangClassId.MESSAGE_UPDATE_START_FIRMWARE]: "Start firmware update",
	[ControllerUiLangClassId.MESSAGE_UPDATE_START_BOOTLOADER]: "Start bootloader update",
	[ControllerUiLangClassId.TABLE_NAME_SERIAL_API_VERSION]: "Serial API Version:",
	[ControllerUiLangClassId.TABLE_NAME_SERIAL_API_VERSION_TITLE]: "It is specific to Z-Wave.Me",
	[ControllerUiLangClassId.TABLE_NAME_VENDOR]: "Vendor:",
	[ControllerUiLangClassId.TABLE_NAME_VENDOR_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_VENDOR_ID]: "Vendor ID:",
	[ControllerUiLangClassId.TABLE_NAME_VENDOR_ID_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_REGION]: "Region:",
	[ControllerUiLangClassId.TABLE_NAME_REGION_TITLE]: "Z-Wave frequency",
	[ControllerUiLangClassId.TABLE_NAME_REGION_SELECT_TITLE]: "Select region",
	[ControllerUiLangClassId.TABLE_NAME_REGION_BUTTON]: "Apply",
	[ControllerUiLangClassId.TABLE_NAME_REGION_BUTTON_TITLE]: "Apply the selected region",
	[ControllerUiLangClassId.TABLE_NAME_RESET_DEFAULT]: "Reset default:",
	[ControllerUiLangClassId.TABLE_NAME_RESET_DEFAULT_TITLE]: "Reset to factory default settings",
	[ControllerUiLangClassId.TABLE_NAME_RESET_DEFAULT_BUTTON]: "Reset",
	[ControllerUiLangClassId.TABLE_NAME_RESET_DEFAULT_BUTTON_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_POWER]: "TX power level:",
	[ControllerUiLangClassId.TABLE_NAME_POWER_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_POWER_SELECT_TITLE]: "Select the TX power level",
	[ControllerUiLangClassId.TABLE_NAME_POWER_BUTTON]: "Apply",
	[ControllerUiLangClassId.TABLE_NAME_POWER_BUTTON_TITLE]: "Apply the selected TX power",
	[ControllerUiLangClassId.TABLE_NAME_UPDATE_FIRMWARE_BUTTON]: "Update",
	[ControllerUiLangClassId.TABLE_NAME_UPDATE_FIRMWARE_BUTTON_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_UPDATE_BOOTLOADER_BUTTON]: "Update",
	[ControllerUiLangClassId.TABLE_NAME_UPDATE_BOOTLOADER_BUTTON_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_LICENSE_UUID]: "UUID:",
	[ControllerUiLangClassId.TABLE_NAME_LICENSE_UUID_TITLE]: "Unique ID of your Z-Wave hardware",
	[ControllerUiLangClassId.TABLE_NAME_LICENSE_MORE_OPTIONS]: "More options:",
	[ControllerUiLangClassId.TABLE_NAME_LICENSE_MORE_OPTIONS_TITLE]: "Additional features available for your hardware",
	[ControllerUiLangClassId.TABLE_NAME_LICENSE_SUBVENDOR_ID]: "Subvendor:",
	[ControllerUiLangClassId.TABLE_NAME_LICENSE_SUBVENDOR_ID_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_LICENSE_MAX_NODE]: "Nodes limit:",
	[ControllerUiLangClassId.TABLE_NAME_LICENSE_MAX_NODE_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_LICENSE_SUPPORT]: "Support:",
	[ControllerUiLangClassId.TABLE_NAME_LICENSE_SUPPORT_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_UPDATE_BETA]: 'Beta:',
	[ControllerUiLangClassId.TABLE_NAME_UPDATE_BETA_SELECT_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_UPDATE_BETA_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_UPDATE_FIRMWARE]: 'Firmware:',
	[ControllerUiLangClassId.TABLE_NAME_UPDATE_FIRMWARE_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_UPDATE_FIRMWARE_SELECT_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_UPDATE_NOT_UPDATE_SELECT_TITLE]: "Not updated",
	[ControllerUiLangClassId.TABLE_NAME_UPDATE_BOOTLOADER]: 'Bootloader:',
	[ControllerUiLangClassId.TABLE_NAME_UPDATE_BOOTLOADER_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_UPDATE_BOOTLOADER_SELECT_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_UPDATE_DOWNLOAD_INFO]: "Download info...",
	[ControllerUiLangClassId.TABLE_NAME_UPDATE_DOWNLOAD_FILE]: "Download file...",
	[ControllerUiLangClassId.TABLE_NAME_UPDATE_WAIT_BUS_SERIAL]: "Wait bus serial...",
	[ControllerUiLangClassId.TABLE_NAME_UPDATE_WAIT_UPDATE]: "Wait update...",
	[ControllerUiLangClassId.TABLE_NAME_DETECTION_SYNC_MANUAL]: 'Sync manual:',
	[ControllerUiLangClassId.TABLE_NAME_DETECTION_SYNC_MANUAL_SELECT_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_DETECTION_SYNC_MANUAL_TITLE]: "",
	[ControllerUiLangClassId.LOG_HEADER]: "Log",
	[ControllerUiLangClassId.LOG_DONE]: " done",
	[ControllerUiLangClassId.LOG_FAILED]: " failed",
	[ControllerUiLangClassId.LOG_FAILED_CODE]: " failed: {{code}}",
	[ControllerUiLangClassId.LOG_UNSUPPORTED]: " unsupported",
	[ControllerUiLangClassId.LOG_NOT_FIND_ELEMENT]: "Not find element: {{element}}",
	[ControllerUiLangClassId.LOG_XHR_TIMEOUT]: "<details><summary>Internet request - timeout </summary><span>{{url}}</span></details>",
	[ControllerUiLangClassId.LOG_XHR_ERROR]: "<details><summary>Internet request - error </summary><span>{{url}}</span></details>",
	[ControllerUiLangClassId.LOG_XHR_INVALID_DATA]: "<details><summary>Internet request - invalid data </summary><span>{{url}}</span></details>",
	[ControllerUiLangClassId.BUTTON_COPY_TEXT]: "Copy log",
	[ControllerUiLangClassId.BUTTON_COPY_TITLE]: "Copy the log to clipboard",
	[ControllerUiLangClassId.BUTTON_CLOSE_TEXT]: "Close",
	[ControllerUiLangClassId.BUTTON_CLOSE_TITLE]: "Closes and stops working with the port",
	[ControllerUiLangClassId.BUTTON_COPY_DSK]: "Copy",
	[ControllerUiLangClassId.BUTTON_COPY_DSK_TITLE]: "Copy the dsk to clipboard",
	[ControllerUiLangClassId.BOARD_INFO_HEADER]: "Board Info",
	[ControllerUiLangClassId.LICENSE_INFO_HEADER]: "License Info",
	[ControllerUiLangClassId.UPDATE_INFO_HEADER]: "Update Info",
	[ControllerUiLangClassId.DEFAULT_RESET_WARNING]: "The Controller Reset will delete all included devices from your network without excluding them. You will need to manually exclude and include all of them. Do you really want to do this?",
	[ControllerUiLangClassId.MIGRATION_INFO_HEADER]: "Migration Info",
	[ControllerUiLangClassId.MIGRATION_ABOUT_HEADER]: "About",
	[ControllerUiLangClassId.MIGRATION_ABOUT_HEADER_TITLE]: "",
	[ControllerUiLangClassId.MIGRATION_ABOUT_HEADER_TEXT_HTML]: "<details><summary>Porting from your old controller</summary><span>to your new Z-Wave.Me hardware</span></details>",
	[ControllerUiLangClassId.MIGRATION_ABOUT_HEADER_TEXT_HTML_RAZ5]: "<details><summary>You have an old stick</summary><span>need a newer one</span></details>",
	[ControllerUiLangClassId.MIGRATION_ABOUT_HEADER_TEXT_HTML_UNSUPPORT]: "<details><summary>Your stick is not supported</summary><span>migration works only to Z-Wave.Me hardware</span></details>",
	[ControllerUiLangClassId.MIGRATION_PROCESS_HEADER]: "Migration:",
	[ControllerUiLangClassId.MIGRATION_PROCESS_HEADER_TITLE]: "",
	[ControllerUiLangClassId.MIGRATION_PROCESS_BUTTON_START]: "Start",
	[ControllerUiLangClassId.MIGRATION_PROCESS_BUTTON_START_TITLE]: "",
	[ControllerUiLangClassId.MIGRATION_PROCESS_BUTTON_START_WARNING]: "Are you sure you want to start the migration process? - During this process, all data will be lost.\nAlso make sure there are no power issues to avoid problems.",
	[ControllerUiLangClassId.MIGRATION_TEST_INCLUDE]: "Checking whether it is on...",
	[ControllerUiLangClassId.MESSAGE_READ_HOME_ID]: "Read home and node id the controller",
	[ControllerUiLangClassId.MIGRATION_UNKNOWN_ERROR]: "An unexpected error occurred, please try again.",
	[ControllerUiLangClassId.MIGRATION_GOOD_RESULT]: "Migration was successful.",
	[ControllerUiLangClassId.MIGRATION_ACTION_STOP]: "Stop",
	[ControllerUiLangClassId.MIGRATION_ACTION_CONTINUE]: "Continue",
	[ControllerUiLangClassId.MIGRATION_ACTION_STOP_TITLE]: "",
	[ControllerUiLangClassId.MIGRATION_ACTION_CONTINUE_TITLE]: "",
	[ControllerUiLangClassId.MIGRATION_QUESTION_EXCLUDE]: "You need to excluding first - click when you're ready",
	[ControllerUiLangClassId.MIGRATION_STOP_RESULT]: "Migration was stoping.",
	[ControllerUiLangClassId.MESSAGE_READ_INIT_DATA]: "Read init data the controller",
	[ControllerUiLangClassId.MESSAGE_START_EXCLUDING]: "Start excluding controller",
	[ControllerUiLangClassId.MESSAGE_START_WIDE_EXCLUDING]: "Start wide excluding controller",
	[ControllerUiLangClassId.SECONDS]: "s",
	[ControllerUiLangClassId.MIGRATION_WAIT_EXCLUDE_START_MASTER]: "We are waiting for you to begin the elimination process.",
	[ControllerUiLangClassId.MESSAGE_CLEAR_NODE]: "Start clear node the controller",
	[ControllerUiLangClassId.MESSAGE_START_INCLUDE]: "Start include controller",
	[ControllerUiLangClassId.MESSAGE_START_WIDE_INCLUDE]: "Start wide include controller",
	[ControllerUiLangClassId.MIGRATION_QUESTION_INCLUDE]: "You need to turn on the controller",
	[ControllerUiLangClassId.MIGRATION_WAIT_INCLUDE_START_MASTER]: "We are waiting for you to begin the inclusion process.",
	[ControllerUiLangClassId.MIGRATION_FINALIZE]: "Finishing...",
	[ControllerUiLangClassId.MIGRATION_DETECTION]: "Detection...",
	[ControllerUiLangClassId.MESSAGE_SET_HOME_ID]: "Set home and node id the controller",
	[ControllerUiLangClassId.MESSAGE_REMOVE_NODE]: "Remove node the controller",
	[ControllerUiLangClassId.MESSAGE_SOFT_RESET]: "Soft reset",
	[ControllerUiLangClassId.MESSAGE_NOP]: "Send nop",
	[ControllerUiLangClassId.MESSAGE_PORT_SELECT]: "Port selection",
	[ControllerUiLangClassId.DETECTION_INFO_HEADER]: "Detection",
	[ControllerUiLangClassId.DETECTION_PROCESS_HEADER]: "Sync:",
	[ControllerUiLangClassId.DETECTION_PROCESS_HEADER_TITLE]: "",
	[ControllerUiLangClassId.DETECTION_PROCESS]: "Sync...",
	[ControllerUiLangClassId.DETECTION_PROCESS_STOP]: "Stop",
	[ControllerUiLangClassId.DETECTION_PROCESS_CONTINUE]: "Continue",
	[ControllerUiLangClassId.DETECTION_PROCESS_STOP_TITLE]: "",
	[ControllerUiLangClassId.DETECTION_PROCESS_CONTINUE_TITLE]: "",
	[ControllerUiLangClassId.DETECTION_PROCESS_QUEST_SYNC]: "Reset your hardware and try again",
	[ControllerUiLangClassId.DETECTION_PROCESS_BUTTON_RE_SYNC]: "Try to sync again",
	[ControllerUiLangClassId.DETECTION_PROCESS_BUTTON_RE_SYNC_TITLE]: "",
	[ControllerUiLangClassId.SLAVE_MESSAGE_READ_BOARD_INFO]: "Read hardware information",
	[ControllerUiLangClassId.TABLE_NAME_VERSION]: "Version:",
	[ControllerUiLangClassId.TABLE_NAME_VERSION_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_BUILD_TIME_STAMP]: "Build date and time:",
	[ControllerUiLangClassId.TABLE_NAME_BUILD_TIME_STAMP_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_UUID]: "UUID:",
	[ControllerUiLangClassId.TABLE_NAME_UUID_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_HOME]: "Home ID:",
	[ControllerUiLangClassId.TABLE_NAME_HOME_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_NODE]: "Node ID:",
	[ControllerUiLangClassId.TABLE_NAME_NODE_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_DSK]: "DSK:",
	[ControllerUiLangClassId.TABLE_NAME_DSK_TITLE]: "Key used to securely include your device",
	[ControllerUiLangClassId.TABLE_NAME_QR_CODE]: "QR-code:",
	[ControllerUiLangClassId.TABLE_NAME_QR_CODE_TITLE]: "QR-code used to securely include your device",
	[ControllerUiLangClassId.SLAVE_MESSAGE_FREEZE_ERROR]: "Failed to pause slave",
	[ControllerUiLangClassId.SLAVE_DEFAULT_RESET_WARNING]: "Do you really want to do this?",
	[ControllerUiLangClassId.TABLE_NAME_TYPE]: "Type:",
	[ControllerUiLangClassId.TABLE_NAME_TYPE_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_TYPE_CONTROLER]: "Controller",
	[ControllerUiLangClassId.TABLE_NAME_TYPE_SLAVE]: "Z-Uno / repeater",
	[ControllerUiLangClassId.ERROR_ARGUMENT_FOR_UPDATE_SELECT]: "error arg for update select",
	[ControllerUiLangClassId.ERROR_ARGUMENT_FIND_TYPE]: "error arg find type",
	[ControllerUiLangClassId.TABLE_NAME_INCLUDE_EXCLUDE]: "Include/Exclude:",
	[ControllerUiLangClassId.TABLE_NAME_INCLUDE_EXCLUDE_TITLE]: "",
	[ControllerUiLangClassId.TABLE_NAME_INCLUDE_EXCLUDE_BUTTON]: "Start",
	[ControllerUiLangClassId.TABLE_NAME_INCLUDE_EXCLUDE_BUTTON_TITLE]: "",
	[ControllerUiLangClassId.INCLUDE_EXCLUDE_WAIT]: "Wait...",
	[ControllerUiLangClassId.MESSAGE_ENABLE_NIF_DEFAULT]: "Enable default NIF",
	[ControllerUiLangClassId.MESSAGE_ENABLE_EVENT_FOR_LEARN]: "Enable event for learn mode",
	[ControllerUiLangClassId.MESSAGE_START_LEARN]: "Start learn mode",
	[ControllerUiLangClassId.MESSAGE_LEARN_INFO_TIMEOUT]: "Learn timout",
	[ControllerUiLangClassId.MESSAGE_LEARN_INFO_TIMEOUT_FORSE_RESTART]: "Learn timeout. Reloading",
	[ControllerUiLangClassId.MESSAGE_LEARN_INFO_INCLUDE_RESTART]: "Included. Reloading",
	[ControllerUiLangClassId.MESSAGE_LEARN_INFO_EXCLUDE_RESTART]: "Excluded. Reloading",
	[ControllerUiLangClassId.PROCESS_CONTINUE]: "Continue",
	[ControllerUiLangClassId.PROCESS_CONTINUE_TITLE]: "",
	[ControllerUiLangClassId.PROCESS_STOP]: "Stop",
	[ControllerUiLangClassId.PROCESS_STOP_TITLE]: "",
	[ControllerUiLangClassId.PROCESS_REPEAT]: "Repeat",
	[ControllerUiLangClassId.PROCESS_REPEAT_TITLE]: "",
	[ControllerUiLangClassId.PROCESS_ABORT]: "Abort",
	[ControllerUiLangClassId.PROCESS_ABORT_TITLE]: "",
	[ControllerUiLangClassId.LEARN_PROCESS_QUEST_EXCLUDE_INCLUDE]: "Ready for inclusion/exclusion by you controller",
	[ControllerUiLangClassId.LEARN_PROCESS_QUEST_EXCLUDE_INCLUDE_TITLE]: "",
	[ControllerUiLangClassId.MIGRATION_NOT_GET_URL_INFO]: "Could not get a link to the information needed for migration",
	[ControllerUiLangClassId.MIGRATION_NOT_UPDATE]: "Failed to update",
	[ControllerUiLangClassId.MIGRATION_LAST_UPDATE_DETECT]: "After the update, the firmware could not be detected",
	[ControllerUiLangClassId.MIGRATION_FAILED_UPDATE_TYPE]: "The type of the updated firmware does not match",
	[ControllerUiLangClassId.MIGRATION_FAILED_UPDATE_VERSION]: "After the update the version is not what it should be",
	[ControllerUiLangClassId.MIGRATION_FAILED_CHANGE_REGION]: "Failed to change frequency",
	[ControllerUiLangClassId.MIGRATION_NOT_SUPPORT_INCLUDE_EXCLUDE]: "No support for exclusion/inclusion",
	[ControllerUiLangClassId.LEARN_PROCESS_QUEST_EXCLUDE]: "Turn on exclusion mode on you controller",
	[ControllerUiLangClassId.LEARN_PROCESS_QUEST_EXCLUDE_TITLE]: "",
	[ControllerUiLangClassId.MIGRATION_LEARN_INFO_EXCLUDE_INCLUDE]: "Learn completed",
	[ControllerUiLangClassId.MIGRATION_FAILED_DETECT]: "Сould not be detected",
	[ControllerUiLangClassId.MIGRATION_PROCESS_QUEST_INCLUDE]: "<div>Turn on inclusion mode on you controller</div><div>When inclusion starts, you have to select all the supported security keys and use the following security code:</div><div>${dsk}</div>",
	[ControllerUiLangClassId.MIGRATION_PROCESS_QUEST_INCLUDE_TITLE]: "",
	[ControllerUiLangClassId.MIGRATION_NOT_SUPPORT_DUMP_KEY]: "No support for dump key",
	[ControllerUiLangClassId.MESSAGE_READ_S2_KEY]: "Reading S2 keys",
	[ControllerUiLangClassId.MIGRATION_NOT_AVIABLE_FIRMWARE]: "The required firmware is not in the database",
	[ControllerUiLangClassId.MIGRATION_NOT_SUPPORT_LR]: "Long Range is not supported",
	[ControllerUiLangClassId.MIGRATION_NOT_SUPPORT_BACKUP]: "Backup is not supported",
	[ControllerUiLangClassId.MIGRATION_FAILED_SEE_LOG]: "Failed - see log",
	[ControllerUiLangClassId.MIGRATION_LEARN_PROCESS_QUEST_EXCLUDE_REPEATER]: "<div>The inclusion happeded without the required keys.</div><div>Please turn on exclusion mode on you controller</div>",
	[ControllerUiLangClassId.MIGRATION_LEARN_PROCESS_QUEST_EXCLUDE_REPEATER_TITLE]: "",
	[ControllerUiLangClassId.MIGRATION_SUCESS]: "Success",
	[ControllerUiLangClassId.MIGRATION_QUEST_REPEATER_ALL_KEY]:  "<div>These are all the keys that we were able to read, is everything correct or will you try again?</div>",
	[ControllerUiLangClassId.MIGRATION_QUEST_REPEATER_ALL_KEY_TITLE]: "",
	[ControllerUiLangClassId.MIGRATION_QUEST_ABORT_STEP]: "An error occurred, would you like to try this step again or abort?",
	[ControllerUiLangClassId.MIGRATION_QUEST_ABORT_STEP_TITLE]: "",
	[ControllerUiLangClassId.MIGRATION_FAILED_REPEAR_TYPE]: "The type of the firmware does not match",
};